/**
 * 登录
 */
import http from '@/http'

export default {
  // 登录
  doLogin(params) {
    return http.post('/login', params)
  },
  // 退出
  // logout() {
  // }
  // 获取统一前端权限资源
  getPermissionResources() {
    return http.get('/public/resources', {
      params: {
        schema: 'WEB'
      }
    })
  },
  // 获取用户菜单权限（兼容旧调用）
  getMenuAuth() {
    return this.getPermissionResources()
  }
}
